[
  {
    "name": "About us",
    "href": "https://deveregroup.wpengine.com/about-us/",
    "submenu": [{
        "name": "Overview",
        "href": "https://www.devere-group.com/about-us/",
        "submenu": null
      },
      {
        "name": "Purpose & Values",
        "href": "https://www.devere-group.com/purpose-values/",
        "submenu": null
      },
      {
        "name": "Leadership",
        "href": "https://www.devere-group.com/leadership-key-people/",
        "submenu": null
      },
      {
        "name": "Commitments",
        "href": "https://www.devere-group.com/commitments/",
        "submenu": null
      },
      {
        "name": "Locations",
        "href": "/",
        "submenu": null
      }
    ]
  },
  {
    "name": "Insights",
    "href": null,
    "submenu": [{
        "name": "Blogs",
        "href": "https://www.devere-group.com/insights/",
        "submenu": null
      },
      {
        "name": "Press Releases",
        "href": "https://www.devere-group.com/press-releases/",
        "submenu": null
      },
      {
        "name": "News",
        "href": "https://www.devere-group.com/newsletters/",
        "submenu": null
      },
      {
        "name": "Learn",
        "href": "https://www.devere-group.com/learn/",
        "submenu": null
      }
    ]
  },
  {
    "name": "What we do",
    "href": "https://www.devere-group.com/what-we-do/",
    "submenu": [
      {
        "name": "Pension Advice",
        "href": "https://www.devere-group.com/what-we-do/pension-advice/",
        "submenu": [
          {
            "name": "Speak to a Pension Specialist",
            "href": "https://www.devere-group.com/get-the-pension-advice-you-need-to-secure-your-future/",
            "submenu": null
          },
          {
            "name": "UK Pension Tracing & Advice",
            "href": "https://www.devere-group.com/what-we-do/pension-advice/how-to-find-lost-pensions-uk/",
            "submenu": null
          },
          {
            "name": "UK Pension Transfer",
            "href": "https://www.devere-group.com/how-to-transfer-uk-pensions/",
            "submenu": null
          },
          {
            "name": "Ongoing Pension Advice (QROPs, SIPPs & QNUPs)",
            "href": "https://www.devere-group.com/what-we-do/pension-advice/pension-servicing-qrops-qnups-sipp/",
            "submenu": null
          }
        ]
      },
      {
        "name": "Investment Management",
        "href": "https://www.devere-group.com/what-we-do/investment-management/",
        "submenu": [
          {
            "name": "Speak with an Investment Adviser",
            "href": "https://www.devere-group.com/secure-your-financial-future-with-professional-advice/",
            "submenu": null
          },
          {
            "name": "Fixed Income Investments",
            "href": "https://www.devere-group.com/what-we-do/investment-management/fixed-income-investments/",
            "submenu": null
          },
          {
            "name": "ESG investing",
            "href": "https://www.devere-group.com/what-we-do/esg-investing/",
            "submenu": null
          }
        ]
      },
      {
        "name": "Tax Planning & Guidance",
        "href": null,
        "submenu": [
          {
            "name": "Speak with a Tax Guide",
            "href": "https://www.devere-group.com/tax-guidance/",
            "submenu": null
          },
          {
            "name": "UK Inheritance Tax",
            "href": "https://www.devere-group.com/what-we-do/investment-management/uk-inheritance-tax/",
            "submenu": null
          }
        ]
      },
      {
        "name": "Financial Planning",
        "href": "https://www.devere-group.com/secure-your-financial-future-with-professional-advice/",
        "submenu": [
          {
            "name": "Speak to a Financial Planner",
            "href": "https://www.devere-group.com/secure-your-financial-future-with-professional-advice/",
            "submenu": null
          },
          {
            "name": "Wealth Management Advisors",
            "href": "https://www.devere-group.com/what-we-do/wealth-management/",
            "submenu": null
          },
          {
            "name": "Retirement Planning",
            "href": "https://www.devere-group.com/what-we-do/pension-advice/retirement-planning/",
            "submenu": null
          },
          {
            "name": "Life insurance Advice",
            "href": "https://www.devere-group.com/life-insurance-advice/",
            "submenu": null
          },
          {
            "name": "Critical Illness Insurance Advice",
            "href": "https://www.devere-group.com/critical-illness-insurance-advice/",
            "submenu": null
          }
        ]
      },
      {
        "name": "Affiliated Fintech Options",
        "href": "https://www.devere-group.com/fintech/",
        "submenu": [
          {
            "name": "Catalyst",
            "href": "https://www.devere-group.com/catalyst/",
            "submenu": null
          },
          {
            "name": "Crypto",
            "href": "https://www.devere-group.com/crypto/",
            "submenu": null
          },
          {
            "name": "Digital Assets",
            "href": "https://www.devere-group.com/what-we-do/digital-assets/",
            "submenu": null
          },
          {
            "name": "Introduction to NFTs",
            "href": "https://www.devere-group.com/what-we-do/digital-assets/an-introduction-to-nfts/",
            "submenu": null
          }
        ]
      }
    ]
  },
  {
    "name": "Worldwide Regulations",
    "href": "https://policies.devere-group.com/regulatory",
    "submenu": null
  },
  {
    "name": "Awards",
    "href": "https://www.devere-group.com/awards-2/",
    "submenu": null
  },
  {
    "name": "Careers",
    "href": "https://www.devere-group.com/careers/",
    "submenu": [
      {
        "name": "Careers Home",
        "href": "https://www.devere-group.com/careers/",
        "submenu": null
      },
      {
        "name": "Wealth Manager Opportunities",
        "href": "https://www.devere-group.com/careers/wealth-manager-opportunities/",
        "submenu": null
      },
      {
        "name": "Investment Banking Opportunities",
        "href": "https://www.devere-group.com/careers/investment-banking-opportunities/",
        "submenu": null
      },
      {
        "name": "Leadership Development Program",
        "href": "https://www.devere-group.com/careers/fast-track-leadership-development-program/",
        "submenu": null
      },
      {
        "name": "Career Pivot",
        "href": "https://www.devere-group.com/careers/career-pivot/",
        "submenu": null
      },
      {
        "name": "Trainee Development Programme",
        "href": "https://www.devere-group.com/careers/trainee-development/",
        "submenu": null
      }
    ]
  }
]
